// Outils pour la date/heure des cours et la salle vidéo

export const OPEN_BEFORE_MIN = 15; // la salle s'ouvre 15 min avant le début
export const CLOSE_AFTER_MIN = 30; // et reste accessible 30 min après la fin

const MINUTE = 60 * 1000;

export const courseStart = (c) =>
  c?.date ? new Date(`${c.date}T${c.time || "00:00"}`) : null;

export const courseEnd = (c) => {
  const start = courseStart(c);
  if (!start) return null;
  return new Date(start.getTime() + (Number(c.duration) || 60) * MINUTE);
};

/** Ex. « mar. 14 oct. · 18:30 (1 h) » */
const TBC = { fr: "À confirmer", nl: "Nog te bevestigen", en: "To be confirmed" };
const LOCALE = { fr: "fr-BE", nl: "nl-BE", en: "en-GB" };

export const formatCourseDate = (c, lang = "fr") => {
  if (!c?.date) return TBC[lang] || TBC.fr;
  const day = courseStart(c).toLocaleDateString(LOCALE[lang] || LOCALE.fr, {
    weekday: "short",
    day: "numeric",
    month: "short",
  });
  if (!c.time) return day;
  const d = Number(c.duration) || 60;
  const h = lang === "fr" ? "h" : lang === "nl" ? "u" : "h";
  const dur = d % 60 === 0 ? `${d / 60} ${h}` : d > 60 ? `${Math.floor(d / 60)} ${h} ${d % 60}` : `${d} min`;
  return `${day} · ${c.time} (${dur})`;
};

/**
 * État de la salle :
 *  - "soon"  : pas encore ouverte (avant début − 15 min)
 *  - "open"  : on peut rejoindre
 *  - "ended" : cours terminé
 */
export const sessionStatus = (c, now = new Date()) => {
  if (!c?.date) return "open";
  if (!c.time) {
    const today = now.toISOString().slice(0, 10);
    return c.date < today ? "ended" : "open";
  }
  const start = courseStart(c).getTime();
  const end = courseEnd(c).getTime();
  if (now.getTime() < start - OPEN_BEFORE_MIN * MINUTE) return "soon";
  if (now.getTime() > end + CLOSE_AFTER_MIN * MINUTE) return "ended";
  return "open";
};

/** Nom de salle Jitsi unique et impossible à deviner */
export const newJitsiRoom = (uuid) => `TatieSoso-${uuid.replace(/-/g, "")}`;

/** Lien Jitsi avec le nom de la personne et le titre du cours pré-remplis */
export const jitsiUrl = (room, displayName, subject) => {
  const params = [
    `userInfo.displayName=${encodeURIComponent(JSON.stringify(displayName || ""))}`,
    `config.subject=${encodeURIComponent(JSON.stringify(subject || "Cours Tatie Soso"))}`,
    "config.prejoinConfig.enabled=true",
  ];
  return `https://meet.jit.si/${encodeURIComponent(room)}#${params.join("&")}`;
};

/** Le cours est-il terminé (heure de fin dépassée) ? → le prof peut être payé */
export const hasCourseEnded = (c, now = new Date()) => {
  if (!c?.date) return false;
  if (!c.time) return c.date < now.toISOString().slice(0, 10);
  return now.getTime() >= courseEnd(c).getTime();
};
